import { RouteWrapper } from "./utils";
import { routes } from "./routes";

export const AppRoutes = () => {
  return <RouteWrapper routes={routes} />;
};
